export default {
  'menu.adminTop': '管理者ホーム',
  'menu.adminTop.users': 'ユーザ管理',
  'menu.adminTop.users.list': 'ユーザ一覧',
  'menu.adminTop.users.create': '新規ユーザ登録',
  'menu.adminTop.users.edit': 'ユーザ編集',
  'menu.adminTop.customers': '契約者管理',
  'menu.adminTop.customers.list': '契約者一覧',
  'menu.adminTop.customers.create': '新規契約者登録',
  'menu.adminTop.customers.edit': '契約者編集',
  'menu.adminTop.customers.note': '契約者メモ登録',

  // Customer
  'menu.customerTop': '契約者ホーム',

  'menu.customerTop.schema': '契約者',
  'menu.customerTop.schema.agencys': '事業者管理',
  'menu.customerTop.schema.agencys.list': '事業者一覧',
  'menu.customerTop.schema.agencys.create': '新規事業者登録',
  'menu.customerTop.schema.agencys.edit': '事業者編集',

  'menu.customerTop.schema.notices': 'お知らせ管理',
  'menu.customerTop.schema.notices.list': 'お知らせ一覧（最大５件）',
  'menu.customerTop.schema.notices.create': '新規お知らせ登録',
  'menu.customerTop.schema.notices.edit': 'お知らせ編集',

  'menu.customerTop.schema.route_groups': '方面管理',
  'menu.customerTop.schema.route_groups.list': '方面一覧',
  'menu.customerTop.schema.route_groups.create': '新規方面登録',
  'menu.customerTop.schema.route_groups.edit': '方面編集',

  'menu.customerTop.schema.route_groups_route': '方面-系統管理',
  'menu.customerTop.schema.route_groups_route.list': '方面-系統一覧',
  'menu.customerTop.schema.route_groups_route.create': '新規方面-系統登録',
  'menu.customerTop.schema.route_groups_route.edit': '方面-系統編集',

  'menu.customerTop.schema.stop_groups': '標柱グループ管理',
  'menu.customerTop.schema.stop_groups.list': '標柱グループ一覧',
  'menu.customerTop.schema.stop_groups.create': '新規標柱グループ登録',
  'menu.customerTop.schema.stop_groups.edit': '標柱グループ編集',

  'menu.customerTop.schema.stop_groups_stop': '標柱グループ-標柱管理',
  'menu.customerTop.schema.stop_groups_stop.list': '標柱グループ-標柱一覧',
  'menu.customerTop.schema.stop_groups_stop.create': '新規標柱グループ-標柱登録',
  'menu.customerTop.schema.stop_groups_stop.edit': '標柱グループ-標柱編集',

  'menu.customerTop.schema.stop_groups.confirm': '標柱グループ-方面確認',

  // --- テンプレ既存 ---
  'menu.more-blocks': 'その他のブロック',
  'menu.home': 'ホーム',
  'menu.admin': '管理者',
  'menu.admin.sub-page': 'サブページ',
  'menu.login': 'ログイン',
  'menu.register': '登録',
  'menu.register-result': '登録結果',
  'menu.dashboard': 'ダッシュボード',
  'menu.dashboard.analysis': '分析',
  'menu.dashboard.monitor': 'モニター',
  'menu.dashboard.workplace': '職場',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'フォーム',
  'menu.form.basic-form': '基本フォーム',
  'menu.form.step-form': 'ステップフォーム',
  'menu.form.step-form.info': 'ステップフォーム（転送情報の書き込み）',
  'menu.form.step-form.confirm': 'ステップフォーム（転送情報の確認）',
  'menu.form.step-form.result': 'ステップフォーム（完成）',
  'menu.form.advanced-form': '高度なフォーム',
  'menu.list': 'リスト',
  'menu.list.table-list': '検索テーブル',
  'menu.list.basic-list': '基本リスト',
  'menu.list.card-list': 'カードリスト',
  'menu.list.search-list': '検索リスト',
  'menu.list.search-list.articles': '検索リスト(記事)',
  'menu.list.search-list.projects': '検索リスト(プロジェクト)',
  'menu.list.search-list.applications': '検索リスト(アプリ)',
  'menu.profile': 'プロフィール',
  'menu.profile.basic': '基本プロフィール',
  'menu.profile.advanced': '高度なプロフィール',
  'menu.result': '結果',
  'menu.result.success': '成功',
  'menu.result.fail': '失敗',
  'menu.exception': '例外',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'トリガー',
  'menu.account': 'アカウント',
  'menu.account.center': 'アカウントセンター',
  'menu.account.settings': 'アカウント設定',
  'menu.account.trigger': 'トリガーエラー',
  'menu.account.logout': 'ログアウト',
  'menu.account.mypage': 'マイページ',
  'menu.account.setting': '個人設定',
  'menu.editor': 'グラフィックエディタ',
  'menu.editor.flow': 'フローエディタ',
  'menu.editor.mind': 'マインドエディター',
  'menu.editor.koni': 'コニエディター',
};
